import {
  Col, Row, Form, Upload, Button, message, Card, Tooltip,
} from 'antd';
import { QuestionCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { any } from 'prop-types';
import { uploadFileUrl } from '@/services/majorFinancing';

const layoutRow = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

export default function OtherUpload({ formRef }) {
  const enterType = Form.useWatch('enterType', formRef);
  const props = {
    name: 'file',
    accept: '.rar,.zip,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.pdf',
    action: uploadFileUrl,
    headers: {
      authorization: 'authorization-text',
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 200;
      if (!isLt2M) {
        message.error('请上传200M以下文件!');
      }
      return isLt2M;
    },
  };

  function getValueFromEvent(e) {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  }

  /**
   * 生成图片列表
   */
  const generateFileInfo = (fileList) => fileList.map((file) => ({
    fileName: file.name || file.fileName,
    fileUrl: file?.response?.data || file.fileUrl || file.url,
  }));

  const onChange = ({ file, fileList }, type) => {
    formRef.setFieldsValue({
      [type]: generateFileInfo(fileList),
    });
    if (file.status === 'done') {
      message.success(`文件【${file.name}】上传成功`);
    } else if (file.status === 'error') {
      message.error('上传失败');
    }
  };

  return (
    <Card title="附件材料" style={{ marginTop: 20 }}>
      <Row>
        <Col span={24}>
          <Form.Item
            style={{ display: 'none' }}
            name="constructionUnit"
          />
          <Form.Item
            {...layoutRow}
            name={['ignore', 'constructionUnit']}
            label={(
              <span>
                  建设单位承诺函
                    <Tooltip title="包括但不限对申报资料真实性、项目建设自筹资金到位、工程建设进度控制等承诺。需单位法人代表签字和单位盖章">
                      <QuestionCircleOutlined />
                    </Tooltip>
              </span>
            )}
            valuePropName="fileList"
            getValueFromEvent={getValueFromEvent}
            rules={[
              {
                required: true,
                message: '请上传建设单位承诺函！',
              },
            ]}
          >
            <Upload
              {...props}
              onChange={(e) => onChange(e, 'constructionUnit')}
            >
              <Button icon={<UploadOutlined />}>上传文件</Button>
            </Upload>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            style={{ display: 'none' }}
            name="studyReport"
          />
          <Form.Item
            {...layoutRow}
            label={(
              <div style={{ lineHeight: '16px', textAlign: 'center' }}>
                项目可研报告
                <br />
                （项目立项前期可行性研究报告等资料）
              </div>
            )}
            name={['ignore', 'studyReport']}
            valuePropName="fileList"
            getValueFromEvent={getValueFromEvent}
            rules={[
              {
                required: true,
                message: '请上传项目可行性研究报告！',
              },
            ]}
          >
            <Upload
              {...props}
              onChange={(e) => onChange(e, 'studyReport')}
            >
              <Button icon={<UploadOutlined />}>上传文件</Button>
            </Upload>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            style={{ display: 'none' }}
            name="leaseAgreement"
          />
          <Form.Item
            {...layoutRow}
            label="项目前期审批资料"
            name={['ignore', 'leaseAgreement']}
            valuePropName="fileList"
            getValueFromEvent={getValueFromEvent}
            rules={[
              {
                required: true,
                message: '请上传项目前期审批资料',
              },
            ]}
          >
            <Upload
              {...props}
              onChange={(e) => onChange(e, 'leaseAgreement')}
            >
              <Button icon={<UploadOutlined />}>上传文件</Button>
            </Upload>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            style={{ display: 'none' }}
            name="approvalDocuments"
          />
          <Form.Item
            {...layoutRow}
            label={(
              <div style={{ lineHeight: '16px', textAlign: 'center' }}>
                建设单位财务报表
                <br />
                （项目建设承担单位近两年的财务报表）
              </div>
            )}
            name={['ignore', 'approvalDocuments']}
            valuePropName="fileList"
            getValueFromEvent={getValueFromEvent}
            rules={[
              {
                required: true,
                message: '请上传建设单位财务报表！',
              },
            ]}
          >
            <Upload
              {...props}
              onChange={(e) => onChange(e, 'approvalDocuments')}
            >
              <Button icon={<UploadOutlined />}>上传文件</Button>
            </Upload>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            style={{ display: 'none' }}
            name="policyDocument"
          />
          <Form.Item
            {...layoutRow}
            label={(
              <div style={{ lineHeight: '16px', textAlign: 'center' }}>
                主导产业发展支持政策文件
                <br />
                （仅附关键页）
              </div>
            )}
            name={['ignore', 'policyDocument']}
            valuePropName="fileList"
            getValueFromEvent={getValueFromEvent}
            rules={[
              {
                required: true,
                message: '请上传主导产业发展支持政策文件！',
              },
            ]}
          >

            <Upload
              {...props}
              onChange={(e) => onChange(e, 'policyDocument')}
            >
              <Button icon={<UploadOutlined />}>上传文件</Button>
            </Upload>

          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            style={{ display: 'none' }}
            name="businessLicense"
          />
          <Form.Item
            {...layoutRow}
            label="营业执照"
            name={['ignore', 'businessLicense']}
            valuePropName="fileList"
            getValueFromEvent={getValueFromEvent}
            rules={[
              {
                required: true,
                message: '请上传营业执照！',
              },
            ]}
          >

            <Upload
              {...props}
              onChange={(e) => onChange(e, 'businessLicense')}
            >
              <Button icon={<UploadOutlined />}>上传文件</Button>
            </Upload>

          </Form.Item>
        </Col>

        {
          enterType === '1' && (
            <>
              <Col span={24}>
                <Form.Item
                  style={{ display: 'none' }}
                  name="leadingEnterprises"
                />
                <Form.Item
                  {...layoutRow}
                  label="龙头企业证明材料"
                  name={['ignore', 'leadingEnterprises']}
                  valuePropName="fileList"
                  getValueFromEvent={getValueFromEvent}
                  rules={[
                    {
                      required: true,
                      message: '请上传龙头企业证明材料！',
                    },
                  ]}
                >

                  <Upload
                    {...props}
                    onChange={(e) => onChange(e, 'leadingEnterprises')}
                  >
                    <Button icon={<UploadOutlined />}>上传文件</Button>
                  </Upload>

                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  style={{ display: 'none' }}
                  name="mainBusiness"
                />
                <Form.Item
                  {...layoutRow}
                  label="主营业务农业产值证明材料"
                  name={['ignore', 'mainBusiness']}
                  valuePropName="fileList"
                  getValueFromEvent={getValueFromEvent}
                  rules={[
                    {
                      required: true,
                      message: '请上传主营业务农业产值证明材料！',
                    },
                  ]}
                >

                  <Upload
                    {...props}
                    onChange={(e) => onChange(e, 'mainBusiness')}
                  >
                    <Button icon={<UploadOutlined />}>上传文件</Button>
                  </Upload>

                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  style={{ display: 'none' }}
                  name="previousYear"
                />
                <Form.Item
                  {...layoutRow}
                  label={(
                    <div style={{ lineHeight: '16px', textAlign: 'center' }}>
                      上年度相关证明材料
                      <br />
                      （销售收入、固定资产、总资产等）
                    </div>
                  )}
                  name={['ignore', 'previousYear']}
                  valuePropName="fileList"
                  getValueFromEvent={getValueFromEvent}
                  rules={[
                    {
                      required: true,
                      message: '请上传上年度相关证明材料！',
                    },
                  ]}
                >

                  <Upload
                    {...props}
                    onChange={(e) => onChange(e, 'previousYear')}
                  >
                    <Button icon={<UploadOutlined />}>上传文件</Button>
                  </Upload>

                </Form.Item>
              </Col>
            </>
          )
        }

        {
          enterType === '2' && (
            <>
              <Col span={24}>
                <Form.Item
                  style={{ display: 'none' }}
                  name="processingFacilities"
                />
                <Form.Item
                  {...layoutRow}
                  label="加工设施设备资金情况证明材料"
                  name={['ignore', 'processingFacilities']}
                  valuePropName="fileList"
                  getValueFromEvent={getValueFromEvent}
                  rules={[
                    {
                      required: true,
                      message: '请上传加工设施设备资金情况证明材料！',
                    },
                  ]}
                >

                  <Upload
                    {...props}
                    onChange={(e) => onChange(e, 'processingFacilities')}
                  >
                    <Button icon={<UploadOutlined />}>上传文件</Button>
                  </Upload>

                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  style={{ display: 'none' }}
                  name="linkingFarmers"
                />
                <Form.Item
                  {...layoutRow}
                  label="联农带农机制证明材料"
                  name={['ignore', 'linkingFarmers']}
                  valuePropName="fileList"
                  getValueFromEvent={getValueFromEvent}
                  rules={[
                    {
                      required: true,
                      message: '请上传联农带农机制证明材料！',
                    },
                  ]}
                >

                  <Upload
                    {...props}
                    onChange={(e) => onChange(e, 'linkingFarmers')}
                  >
                    <Button icon={<UploadOutlined />}>上传文件</Button>
                  </Upload>

                </Form.Item>
              </Col>
            </>
          )
        }
        <Col span={24}>
          <Form.Item
            style={{ display: 'none' }}
            name="otherDocument"
          />
          <Form.Item
            {...layoutRow}
            name={['ignore', 'otherDocument']}
            valuePropName="fileList"
            getValueFromEvent={getValueFromEvent}
            label="其他必要的相关材料"
          >
            <Upload
              {...props}
              onChange={(e) => onChange(e, 'otherDocument')}
            >
              <Button icon={<UploadOutlined />}>上传文件</Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
}
OtherUpload.propTypes = {
  formRef: any,
};
